
/** *
 * 命中灰度策略枚举
 * waitHint:命中
 * noHint: 未命中
 * 注意⚠️：新增实验不要再用这个枚举，请使用ABResEnum（全局搜索一下）
 * ** */
export enum AbTestEnum {
    /** 命中 */
    waitHint = '1',
    /** 未命中 */
    noHint = '2',
    /** 等待结果中，初始化状态 */
    default = '-1'
}

export enum UserCertEnum {
    /** 金融独立实名模式（老用户） */
    FinanceUser = 1,
    /** 平台打通实名模式（新用户） */
    Platform = 2,
}

export enum HelloCertEnum {
    /** 未实名 */
    NO_VERIFICY = 1,
    /** 身份证实名 */
    IDENTITY_VERIFICY= 2,
    /** 非身份证实名 (老用户没有这个字段) */
    NOT_IDENTITY_VERIFICY= 3,
}

export interface AbTestArgs {
    [propName: string]: string;
}

/** *
 * 命中灰度策略枚举
 * ** */
export enum DivideEnum {
    /**
     * 强制合同阅读5s
     * 非伽利略，50%，50%
     */
    contractWaitDivide = 'contractWaitDivide',
    /**
     * 绑卡页面视觉优化abtest
     * 非伽利略，后端代码已下线，userId 不为空是实验组，前端无调用
     */
    lendingTimeRule = 'lendingTimeRule',

    /**
     * 个人资料填写页abtest
     * 实验地址：https://ab.hellobike.cn/experiment/detail/202209191128571383?isDetail=true
     * 实验状态：已推全，可以下掉
     */
    dataPageOptimize = 'dataPageOptimize',


    /**
     * 授信阶段补充资料
     * 实验地址: https://ab.hellobike.cn/experiment/detail/202210121941333480?isDetail=true
     * 实验状态: 已推全，可以下掉调用逻辑
    */
    supplyParamDivide= 'supplyParamDivide',


    /**
     * 提现环节诈骗弹窗展示abtest
     * 实验地址: https://ab.hellobike.cn/experiment/detail/202211301046382541?isDetail=true
     * 实验状态: 已推全，可以去掉调用逻辑
     */
    antiFraudAlert= 'antiFraudAlert',

    /**
     * 支付宝小程序下载页ab
     * 实验地址: https://ab.hellobike.cn/experiment/detail/202211211859094655?isDetail=true
     * 实验状态：已过期 默认走对照组（待找伽利略确认）
     */
    miniDispatchLendingPage = 'miniDispatchLendingPage',


    /**
     * 新版授信协议页切量试验
     * 实验地址：https://ab.hellobike.cn/experiment/detail/202301091355579512?isDetail=true
     * 实验状态：已推全，可以下掉接口调用逻辑
    */
    creditContractDisplayAbTest = 'creditContractDisplayAbTest'
}
export interface AbTestResult {
    divideRes: AbTestEnum
}

export interface AbTestQuery {
    divideType: string,
    productIdList?:string[]
}
